<template>
  <div v-if="Object.keys(allData).length" class="report-13" dir="rtl">
    <img class="report-logo" src="/img/ns.png" alt="" />
    <header class="report-header">
      <div class="title">
        <h2 class="text-center">{{ name }}</h2>
        <h2 class="text-center">{{ desc }}</h2>
      </div>
      <div class="dates">
        <div>
          <!-- <p>الكشف التحليلى لشهر :</p> -->
          <p>{{ month }}</p>
        </div>
        <div>
          <p>تاريخ الطباعة :</p>
          <p>{{ date }}</p>
        </div>
      </div>
    </header>
    <section class="analytical-detection-body">
      <div class="head">
        <p class="salary text-center">المرتب الأساسى والعلاوات</p>
        <p class="discount text-center">الخصميات</p>
      </div>
      <div class="sub-head">
        <div class="sub-salary">
          <div class="loop">
            <p>الأساسى</p>
            <p>اللجان</p>
            <p>المكافأت</p>
            <p>العمل الإضافى</p>
          </div>
          <div class="loop">
            <p v-for="(item, i) in allData.allowances" :key="'key' + i">
              {{ item.key }}
            </p>
          </div>
          <!-- <div>
            <p>علاوات أخرى</p>
            <p>مكافأة</p>
          </div> -->
        </div>
        <div class="sub-discount">
          <div>
            <p>ضمان</p>
            <p>تضامن</p>
          </div>
          <div>
            <p>جهاد</p>
            <p>دخل</p>
          </div>
          <div>
            <p>دينار</p>
            <p>الدمغة</p>
          </div>
          <div>
            <p>خ.عقوبة</p>
            <p>غياب</p>
          </div>
          <div>
            <p>نفقة شرعية</p>
            <p>ق.سلفة</p>
          </div>
          <div>
            <p>اخرى</p>
            <p>تأمين طبى</p>
          </div>
        </div>
      </div>
      <div class="sub-body">
        <div class="sub-salary">
          <div class="loop">
            <p>{{ allData.totalSalaries }}</p>
            <p>{{ allData.totalCommitteesAllownace }}</p>
            <p>{{ allData.totalRewards }}</p>
            <p>{{ allData.totalOverTime }}</p>
          </div>
          <div class="loop">
            <p v-for="(item, i) in allData.allowances" :key="'value' + i">
              {{ item.value }}
            </p>
          </div>
        </div>
        <div class="sub-discount">
          <div>
            <p>{{ allData.totalWarrantyTax }}</p>
            <p>{{ allData.totalSolidarityTax }}</p>
          </div>
          <div>
            <p>{{ allData.totalJihadTax }}</p>
            <p>{{ 0 }}</p>
          </div>
          <div>
            <p>{{ allData.totalDinarTax }}</p>
            <p>{{ allData.totalStampTax.toFixed(3) }}</p>
          </div>
          <div>
            <p>{{ 0 }}</p>
            <p>{{ allData.totalAbsanceDiscount }}</p>
          </div>
          <div>
            <p>{{ allData.totalLegalExpenseDiscount }}</p>
            <p>{{ allData.totalCreditDiscount }}</p>
          </div>
          <div>
            <p>{{ allData.totalOtherDiscounts }}</p>
            <p>{{ 0 }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="analytical-detection-result">
      <div class="right-result">
        <p>عدد الموظفين</p>
        <div class="staff-number text-center">{{ allData.employeesCount }}</div>
        <div class="all">
          <p>إجمالى المرتبات</p>
          <p>علاوة بالصافى</p>
        </div>
        <div class="result">
          <p>{{ allData.totalBasicSalaries }}</p>
          <p>{{ allData.totalAllowances }}</p>
        </div>
      </div>
      <div class="left-result">
        <p>الاستقطاعات</p>
        <p>{{ allData.totalDiscounts }}</p>
        <p>الصافى</p>
        <div class="pure text-center">{{ allData.totalNetSalaries }}</div>
      </div>
    </section>
    <section class="analytical-detection-details">
      <div class="first"></div>
      <div class="second">
        <p>تفصيل العلاوات الاخرى والخصميات الاخرى</p>
        <div class="text-center">{{ 0 }}</div>
      </div>
    </section>
    <section class="bosses">
      <p>رئيس قسم الحسابات</p>
      <p>المراجعة الداخلية</p>
      <p>المراقب المالى</p>
    </section>
    <section class="final-result">
      <div class="right">
        <div class="t-header">
          <p>الخصميات</p>
          <p>المعتمد</p>
          <p>المصروف</p>
          <p>الرصيد</p>
          <p>صفحة سجل الاعتماد</p>
        </div>
        <!-- <div class="t-body">
          <p>الخصميات</p>
          <p>المعتمد</p>
          <p>المصروف</p>
          <p>الرصيد</p>
          <p>صفحة سجل الاعتماد</p>
        </div>
        <div class="t-body">
          <p>الخصميات</p>
          <p>المعتمد</p>
          <p>المصروف</p>
          <p>الرصيد</p>
          <p>صفحة سجل الاعتماد</p>
        </div> -->
      </div>
      <div class="left">
        <div>
          <p>حصة جهة العمل</p>
          <p>{{ allData.totalEmployerTax }}</p>
        </div>
        <div>
          <p>حصة الخزينة</p>
          <p>{{ allData.totalCabinetTax }}</p>
        </div>
        <hr />
        <hr />
        <div>
          <p>المجموع % 11.25</p>
          <p>{{ allData.totalEmployerTax + allData.totalCabinetTax }}</p>
        </div>
        <hr />
        <hr />
        <div>
          <p>عدد الموقوفين</p>
          <p>{{ allData.suspendedCount }}</p>
        </div>
        <div>
          <p>مرتبات الموقوفين</p>
          <p>{{ allData.suspendedSalaries }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["month", "date", "name", "desc", "allData"],
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/report-13";
</style>
